<template>
    <form-view class="lottery-service-detail-view">
        <template slot="field">
            <h3>基本信息</h3>
            <veui-field label="应用名称：">
                <veui-span>{{ store.serviceDetail.appName }}</veui-span>
            </veui-field>
            <veui-field label="服务名称：">
                <veui-span>{{ store.serviceDetail.name }}</veui-span>
            </veui-field>
            <veui-field label="authKey：">
                <veui-span>{{ authKey }}</veui-span>
            </veui-field>
            <veui-field label="activityId：">
                <veui-span>{{ activityId }}</veui-span>
            </veui-field>
            <veui-field label="数据接收邮箱：">
                <veui-span>{{ store.serviceDetail.mailReceiver }}</veui-span>
            </veui-field>
            <veui-field label="数据解压密码：">
                <veui-span>{{ store.serviceDetail.zipPassword }}</veui-span>
            </veui-field>
            <veui-field label="活动描述：">
                <veui-span>{{ store.serviceDetail.description }}</veui-span>
            </veui-field>
            <h3>领券奖项</h3>
            <veui-table :data="store.serviceDetail.awards || []">
                <veui-table-column title="奖项名称" field="name">
                    <template slot-scope="props">
                        <p class="table-multi-line">{{ props.name }}</p>
                    </template>
                </veui-table-column>
                <veui-table-column title="奖项描述" field="description">
                    <template slot-scope="props">
                        <p class="table-multi-line">{{ props.description }}</p>
                    </template>
                </veui-table-column>
                <veui-table-column title="短信模板" field="smsTemplate">
                    <template slot-scope="props">
                        <p class="table-multi-line">{{ props.smsTemplate }}</p>
                    </template>
                </veui-table-column>
                <veui-table-column title="每日最多领券数量" field="availablePerDay" />
            </veui-table>
        </template>
        <template slot="operation">
            <veui-button @click="back">{{ cancelText }}</veui-button>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import FormModel from './FormModel';
import createView from '@baidu/ve-ria/views/createView';
import {Field, Table, Button, Span, Column} from 'veui';
import serviceMixin from '@/common/mixins/service';
import {get} from 'lodash';

export default createView(FormView, FormModel, {
    name: 'LotteryServiceFormView',
    components: {
        'veui-field': Field,
        'veui-table': Table,
        'veui-span': Span,
        'veui-button': Button,
        'veui-table-column': Column
    },
    mixins: [serviceMixin],
    computed: {
        authKey() {
            return get(this.store.serviceDetail, 'authKey');
        },
        activityId() {
            return get(this.store.serviceDetail, 'activityId');
        }
    }
});
</script>

<style lang="less">
.lottery-service-detail-view {
    .veui-form-label {
        min-width: 130px;
    }
    .veui-input-input {
        width: 300px;
    }
}
.add-award-dialog {
    .veui-dialog-content {
        width: 600px;
    }
}
</style>
